import { useEffect, useState } from 'react';
import serviceMethods from '../../service';

const Dashboard = ({ id = null, type = 'clubMembers', setIsLoading }) => {
  const [iFrame, setIFrame] = useState(null);

  const dashObj = id ? { id } : { name: type };

  const fetchDashboard = async () => {
    const res = await serviceMethods.getOmniDashboard(dashObj);
    const data = await res.json();
    const { iframeUrl } = data;
    setIFrame(iframeUrl);
  };

  useEffect(() => {
    setIsLoading(true);
    fetchDashboard();
  }, [id]);

  return (
    <div className="flex h-full w-full flex-col items-center">
      {iFrame && (
        <iframe
          className="rounded-lg border-1"
          title="Dashboard"
          width="100%"
          height="680px"
          src={iFrame}
          onLoad={() => {
            setIsLoading(false);
          }}
        />
      )}
    </div>
  );
};

export default Dashboard;
